// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2744":"85df346e12976780","3528":"61dd147cad2184d0","3567":"9e46c6487970a4e9","4366":"eb102e6d2267b501","7253":"1055cacc6b10ff6e","8142":"e9a1fa5b7167fc55"}[chunkId] + ".css";
};